document.addEventListener('DOMContentLoaded', function () {

  /*
    Detecție OS (iOS vs Android), pentru cazurile rare în care un
    fix de poziționare arată bine pe un sistem, dar prost pe altul.
    Adaugă clasa pe <body>, disponibilă în orice CSS din site.
  */
  var ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) {
    document.body.classList.add('is-ios');
  } else if (/Android/i.test(ua)) {
    document.body.classList.add('is-android');
  }

  const header = document.querySelector('.fc-header');
  const hamburger = document.querySelector('.fc-hamburger');
  const mobileMenu = document.querySelector('.fc-mobile-menu');
  const overlay = document.querySelector('.fc-mobile-menu__overlay');
  const closeBtn = document.querySelector('.fc-mobile-menu__close');
  const groupBtns = document.querySelectorAll('.fc-mobile-nav__group-btn');
  const dropdowns = document.querySelectorAll('.fc-nav__item--dropdown');

  function isDesktop() {
    return window.innerWidth > 1024;
  }

  // Dropdown-uri desktop (Legends, Leagues, Cont, Coș)
  dropdowns.forEach(function (dropdown) {
    var trigger = dropdown.querySelector('.fc-nav__trigger, .fc-cart-btn');
    var closeTimer = null;

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        if (!isDesktop()) return;
        e.stopPropagation();
        var isOpen = dropdown.classList.contains('is-open');
        dropdowns.forEach(function (d) { d.classList.remove('is-open'); });
        if (!isOpen) dropdown.classList.add('is-open');
      });
    }

    dropdown.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      dropdowns.forEach(function (d) {
        if (d !== dropdown) d.classList.remove('is-open');
      });
      dropdown.classList.add('is-open');
    });

    dropdown.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      closeTimer = setTimeout(function () {
        dropdown.classList.remove('is-open');
      }, 300);
    });
  });

  document.addEventListener('click', function () {
    if (!isDesktop()) return;
    dropdowns.forEach(function (d) { d.classList.remove('is-open'); });
  });

  // Scroll behavior (header sticky, se ascunde la scroll jos)
  var lastScroll = 0;
  var headerHeight = header.offsetHeight;
  var scrollBeforeHide = 80;
  var scrollReady = false;
  setTimeout(function () { scrollReady = true; }, 1500);

  window.addEventListener('scroll', function () {
    if (!scrollReady) return;
    var currentScroll = window.scrollY;

    if (currentScroll > lastScroll && currentScroll > scrollBeforeHide) {
      var offset = Math.min(currentScroll - scrollBeforeHide, headerHeight);
      header.style.transform = 'translateY(-' + offset + 'px)';
      if (offset >= headerHeight) {
        header.style.opacity = '0';
        header.style.pointerEvents = 'none';
      } else {
        header.style.opacity = String(1 - offset / headerHeight);
        header.style.pointerEvents = 'auto';
      }
    } else if (currentScroll < lastScroll) {
      header.style.transform = 'translateY(0)';
      header.style.opacity = '1';
      header.style.pointerEvents = 'auto';
    }

    lastScroll = currentScroll;
  });

  // Mobile menu (drawer)
  function openMenu() {
    mobileMenu.classList.add('is-open');
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  // Dropdown-uri mobile (Legends, Leagues) - expand cu animație staggered
  groupBtns.forEach(function (btn) {
    var sub = btn.nextElementSibling;
    if (sub) {
      var subItems = sub.querySelectorAll('.fc-mobile-nav__sub-item');
      subItems.forEach(function (item, i) {
        item.style.transitionDelay = (i * 45) + 'ms';
      });
    }

    btn.addEventListener('click', function () {
      var isOpen = btn.classList.contains('is-open');
      groupBtns.forEach(function (b) {
        b.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
        if (b.nextElementSibling) b.nextElementSibling.classList.remove('is-open');
      });
      if (!isOpen) {
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        if (sub) sub.classList.add('is-open');
      }
    });
  });

  /*
    MINI-CART: modificare cantitate / ștergere produs, direct din
    preview-ul de la hover, fără reîncărcarea paginii (Shopify Ajax Cart API).
    Activ doar pe desktop - pe mobil, tap pe iconița de coș duce direct la /cart.
  */
  var cartBody = document.getElementById('fc-dropdown-cart-body');

  var cartCurrency = 'RON';

function money(cents) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: cartCurrency
    }).format(cents / 100);
  } catch (e) {
    return (cents / 100).toFixed(2) + ' ' + cartCurrency;
  }
}

  function renderCartBody(cart) {
    if (!cartBody) return;

    if (cart.item_count === 0) {
      cartBody.innerHTML = '<div class="fc-cart-empty">Your cart is empty</div>';
      return;
    }

    var shown = cart.items.slice(0, 2);
    var itemsHtml = shown.map(function (item) {
      var img = item.image
        ? `<img src="${item.image}" alt="" class="fc-cart-item__img" width="40" height="40">`
        : '';
      return `
        <div class="fc-cart-item" data-key="${item.key}">
          ${img}
          <div class="fc-cart-item__info">
            <div class="fc-cart-item__title">${item.product_title}</div>
            <div class="fc-cart-item__qty-controls">
              <button class="fc-cart-qty-btn" data-action="decrease" aria-label="Decrease quantity">-</button>
              <span class="fc-cart-item__qty-value">${item.quantity}</span>
              <button class="fc-cart-qty-btn" data-action="increase" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <div class="fc-cart-item__right">
            <div class="fc-cart-item__price">${money(item.final_line_price)}</div>
            <button class="fc-cart-item__remove" aria-label="Remove item">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 2L10 10M10 2L2 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
            </button>
          </div>
        </div>`;
    }).join('');

    var moreCount = cart.items.length - 2;
    var moreHtml = moreCount > 0
      ? `<div class="fc-cart-more" id="fc-cart-more">+${moreCount} more</div>`
      : '';

    cartBody.innerHTML = `
      <div class="fc-cart-items" id="fc-cart-items">${itemsHtml}</div>
      ${moreHtml}
      <div class="fc-cart-total"><span>Total</span><span id="fc-cart-total-value">${money(cart.total_price)}</span></div>
      <a href="/cart" class="fc-dropdown__item fc-dropdown__item--all fc-cart-viewall" role="menuitem">View cart →</a>
    `;
  }

  function updateCartBadges(cart) {
    var badge = document.getElementById('fc-cart-count');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count === 0 ? 'none' : 'flex';
    }
    var mobileLabel = document.getElementById('fc-cart-count-mobile');
    if (mobileLabel) {
      mobileLabel.textContent = 'View cart (' + cart.item_count + ')';
    }

    /*
      Actualizare live pentru panoul auriu de coș din meniul mobil,
      la fel ca dropdown-ul desktop, fără reload.
    */
    var mobileCountEl = document.getElementById('fc-mobile-cart-count');
    if (mobileCountEl) {
      mobileCountEl.textContent = cart.item_count;
    }

    var mobilePanelBody = document.getElementById('fc-mobile-cart-panel-body');
    if (mobilePanelBody) {
      if (cart.item_count === 0) {
        mobilePanelBody.innerHTML = '<div class="fc-mobile-cart-panel__empty">Your cart is empty</div>';
      } else {
        var first = cart.items[0];
        var imgHtml = first.image
          ? '<img src="' + first.image + '" alt="" class="fc-mobile-cart-panel__img" width="26" height="26">'
          : '';
        var moreText = cart.items.length > 1
          ? '+' + (cart.items.length - 1) + ' more · '
          : '';

        mobilePanelBody.innerHTML =
          '<div class="fc-mobile-cart-panel__item">' +
            imgHtml +
            '<div class="fc-mobile-cart-panel__title">' + first.product_title + '</div>' +
            '<div class="fc-mobile-cart-panel__price">' + money(first.final_line_price) + '</div>' +
          '</div>' +
          '<div class="fc-mobile-cart-panel__more">' + moreText + 'Total ' + money(cart.total_price) + '</div>';
      }
    }
  }
  window.fcUpdateCartUI = function (cart) {
    renderCartBody(cart);
    updateCartBadges(cart);
  };

  function changeLineQuantity(key, quantity) {
    var lineEl = cartBody.querySelector('[data-key="' + key + '"]');
    if (lineEl) lineEl.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartBody(cart);
        updateCartBadges(cart);
      })
      .catch(function () {
        if (lineEl) lineEl.classList.remove('is-updating');
      });
  }

  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var lineEl = e.target.closest('.fc-cart-item');
      if (!lineEl) return;
      var key = lineEl.dataset.key;

      if (e.target.closest('[data-action="increase"]')) {
        var q1 = parseInt(lineEl.querySelector('.fc-cart-item__qty-value').textContent, 10);
        changeLineQuantity(key, q1 + 1);
      } else if (e.target.closest('[data-action="decrease"]')) {
        var q2 = parseInt(lineEl.querySelector('.fc-cart-item__qty-value').textContent, 10);
        changeLineQuantity(key, Math.max(0, q2 - 1));
      } else if (e.target.closest('.fc-cart-item__remove')) {
        changeLineQuantity(key, 0);
      }
    });
  }
});

/* ================================
   LOCALIZATION SELECTORS (JS propriu — Dawn's localization-form.js
   depinde de .menu-drawer, care nu există în acest header custom)
   ================================ */
document.addEventListener('DOMContentLoaded', function () {
  function closeAllPanels() {
    document.querySelectorAll('.fc-localization-instance .disclosure__list-wrapper').forEach(function (panel) {
      panel.setAttribute('hidden', '');
      var disclosure = panel.closest('.disclosure');
      var btn = disclosure && disclosure.querySelector('button');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('.fc-localization-instance .disclosure').forEach(function (disclosure) {
    var button = disclosure.querySelector('button');
    var panel = disclosure.querySelector('.disclosure__list-wrapper');
    if (!button || !panel) return;

    button.addEventListener('click', function (e) {
      e.stopPropagation();
      var wasHidden = panel.hasAttribute('hidden');
      closeAllPanels();
      if (wasHidden) {
        panel.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'true');
      }
    });

    disclosure.querySelectorAll('a[data-value]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var form = disclosure.closest('form');
        if (!form) return;
        var input = form.querySelector('input[name="locale_code"], input[name="country_code"]');
        if (input) input.value = link.dataset.value;
        form.submit();
      });
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.fc-localization-instance')) closeAllPanels();
  });
});